<template lang="">
    <section>
        <a :href="banner.link" :target="banner.linkTarget">
            <!-- <h1 class="text-xl text-primary font-bold">{{ title }}</h1> -->
            <!-- <p class="text-sm mb-2">{{ text }}</p> -->
            <div class="relative">
                <!-- <div class="absolute bottom-0 mb-6 left-1/2 -translate-x-1/2 whitespace-nowrap">
                    <button class="text-primary font-bold rounded-sm border-[1px] border-primary bg-white p-4">{{ textButton }}</button>
                </div> -->
                <img class="rounded-2xl" :src="banner.mediaUrl" alt="">
            </div>
        </a>
    </section>
</template>
<script>
export default {
    props: {
        banner: Object
    },
}
</script>
